










































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import FileSelector from "@/components/common/FileSelector.vue";
import { getModule } from "vuex-module-decorators";
import Decisions from "@/store/modules/Decisions";

import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import Choices from "@/store/modules/Choices";
import ChoiceSubmitterGroup from "@/views/ChoiceSubmitter/ChoiceSubmitterRecursiveGroup.vue";
import { NotificationEventBus } from "@/EventBus";
import Modelling from "@/store/modules/Modelling";

const modellingModule = getModule(Modelling);
const decisionsModule = getModule(Decisions);
const choicesModule = getModule(Choices);
const workspaceOptionsModule = getModule(WorkspaceOptions)
@Component(
    {
        components: {
            ChoiceSubmitterGroup,
            FileSelector
        }
    })
export default class ChoiceInputSubTree extends Vue {

    @Prop()
    groupId!: string;

    @Prop()
    choiceId!: string

    @Ref()
    private form: HTMLFormElement;

    private choiceForm: any = {}
    private submitting = false;

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get choice() {
        return choicesModule.choices[this.choiceId];
    }

    @Watch('groupId')
    @Watch('choiceId')
    private mainResourcesChanged() {
        this.choiceForm = JSON.parse(JSON.stringify(this.choice));
    }

    mounted() {
        this.mainResourcesChanged();
    }

    private async updateChoice() {
        if (!this.form.validate()) {
            return;
        }

        this.submitting = true;
        NotificationEventBus.emitProcessingMessage();
        try {
            await choicesModule.updateChoice({choice: this.choiceForm, refreshScoring: true})
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err)
        }
        this.submitting = false;
    }
}
